import CodeSplitEnvWrapper from '../../../components/common/env/CodeSplitEnvWrapper';
import { SCREENS } from '../../../constants/tracking/Screens';
import { APP } from '../../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { planBuilderCheckoutProductConfigurationsSelector, planBuilderCommonTermForProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { upgradeProductSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const PlanBuilderCTA = ({
  purchaseMotion,
  onClick,
  termOverride,
  hubsSignupProductOverride,
  trackingSource,
  sourceId = 'pricing-middle',
  screen = SCREENS.PRODUCTS_PLANS,
  use = 'primary',
  block,
  size,
  children
}) => {
  const checkoutProductConfigurations = useAppSelector(planBuilderCheckoutProductConfigurationsSelector);
  const commonTermForProductConfigurations = useAppSelector(planBuilderCommonTermForProductConfigurationsSelector);
  const upgradeProduct = useAppSelector(state => upgradeProductSelector(state, {
    skuIds: checkoutProductConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const upgradeData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${upgradeProduct}`,
    upgradeProduct
  };
  const sharedProps = {
    onClick,
    trackingSource,
    use,
    block,
    children,
    size
  };
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */'ui-addon-upgrades/button/UIContactSalesButton'),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */'pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton'),
    authedComponentProps: Object.assign({}, sharedProps, {
      upgradeData,
      isAssignable: false
    }),
    publicComponentProps: Object.assign({}, sharedProps, {
      sourceId,
      productConfigurations: checkoutProductConfigurations,
      dtbSource: `pricing-page|${trackingSource}`,
      hubsSignupProductOverride,
      purchaseMotion,
      queryParamTerm: termOverride !== null && termOverride !== void 0 ? termOverride : commonTermForProductConfigurations
    })
  });
};
export default PlanBuilderCTA;